module.exports = __webpack_public_path__ + "img/mercedes.61a9224e.webp";